import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { useLazyGetVendorShipmentCountsQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportVendorShipmentCount = () => {
    const [fetchVendorShipmentCounts, { isLoading, isFetching }] =
        useLazyGetVendorShipmentCountsQuery();

    const handleDownload = async () => {
        try {
            const responseData = await fetchVendorShipmentCounts({
                // No limit to get all data for export
            }).unwrap();

            if (!responseData?.data || responseData.data.length === 0) {
                toast.info("No data.");
                return;
            }

            const formattedData = responseData?.data.map((row, index) => ({
                SN: index + 1,
                "Shop Name": row.shopName || "N/A",
                "Owner Name": row.ownerName || "N/A",
                Email: row.email || "N/A",
                Phone: row.phone || "N/A",
                Address: row.address || "N/A",
                "Shipment Count": row.shipmentCount || 0,
            }));

            exportExcelFile({
                sheetData: formattedData,
                fileName: "Vendor_Shipment_Count_Report",
            });

            toast.success("Data downloaded successfully");
        } catch (error) {
            toast.error(
                "Error fetching vendor shipment count data: " + error.message
            );
        }
    };

    return (
        <div>
            <Tooltip title="Export Excel" arrow>
                <IconButton
                    color="success"
                    onClick={handleDownload}
                    disabled={isLoading || isFetching}
                >
                    <FileDownloadOutlined />
                </IconButton>
            </Tooltip>
        </div>
    );
};

export default ExportVendorShipmentCount;